// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import CountriesList from '../../constants/CountriesList';
import PhoneUtils from '../../utils/PhoneUtils';

import ViewConstants from '../../constants/ViewConstants';

// -- views
import LocalizableSelect from './LocalizableSelect';

/**
 * TODO: work in progress.
 * Resources:
 *  - https://github.com/razagill/react-phone-input
 *  - https://github.com/googlei18n/libphonenumber
 *  -
 */
class PhoneInput extends Component {

  static defaultProps = {
    defaultCountryIso: 'FR',

    value: '',

    placeholder: '6 00 00 00 00'
  };

  static propTypes = {
    // (Country code 'FR' for example.)
    defaultCountryIso: PropTypes.string,

    value: PropTypes.string,

    placeholder: PropTypes.string,

    /**
     * @param number The phone number
     */
    onChange: PropTypes.func.isRequired
  };

  state = this.getInitialState();

  getInitialState() {
    const countryIso: string = this.getPropsValueIso();

    return {
      countryIso,

      /**
       * See https://github.com/googlei18n/libphonenumber PhoneNumber class.
       * - country_code
       * - national_number
       */
      numberInfo: PhoneUtils.parseWithIso(this.props.value, countryIso)
    };
  }

  getPropsValueIso(): string {
    const iso = PhoneUtils.getCountryIsoForNumber(this.props.value);

    if (!_.isNull(iso)) {
      return iso;
    }

    return this.props.defaultCountryIso;
  }

  // -- events
  onCountryChange = (option) => {
    const countryIso = option.value;

    if (countryIso !== this.state.countryIso) {
      this.updateFormattedNumber(this.state.numberInfo.national_number, countryIso);
    }
  };

  onNumberChange = (event) => {
    const value = event.target.value;

    this.updateFormattedNumber(value, this.state.countryIso);
  };

  updateFormattedNumber(number, countryIso) {
    const numberInfo = PhoneUtils.parseWithIso(number, countryIso);

    const haveIndicator = numberInfo.national_number.indexOf('+') !== -1;
    const firstSpaceIndex = numberInfo.national_number.indexOf(' ');

    if (firstSpaceIndex !== -1) {
      numberInfo.national_number = numberInfo.national_number.substring(firstSpaceIndex + 1);
    }


    this.setState({
      countryIso,
      numberInfo
    });
  }

  // -- renderers

  render() {
    const options = CountriesList.getCountriesListForPicker();

    return (
      <div className="phone_input">
        <div className="phone_input__country_select">
          {/* <LocalizableSelect
            name="action"
            value={this.state.countryIso}
            options={options}
            onChange={this.onCountryChange}
            optionComponent={CountryOption}
            valueComponent={CountryValue}
            clearable={false}
          /> */}
        </div>
        <br />
        <div className="phone_input__phone_input">
          <div className="input-group-addon">
            {this.state.numberInfo.country_code !== -1 &&
              <span className="phone_input__country_code">+{this.state.numberInfo.country_code}</span>
            }
          </div>
          <input
            type="tel"
            autoComplete="off"
            className="form-control"
            value={PhoneUtils.removeIndicatorOnPhoneNumber(this.state.numberInfo.national_number)}
            onChange={this.onNumberChange}
            placeholder={this.props.placeholder}
          />
        </div>
      </div>
    );
  }

}

class CountryOption extends Component {

  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    isDisabled: PropTypes.bool,
    isFocused: PropTypes.bool,
    isSelected: PropTypes.bool,
    onFocus: PropTypes.func,
    onSelect: PropTypes.func,
    option: PropTypes.object.isRequired
  };

  handleMouseDown = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.props.onSelect(this.option, event);
  };

  handleMouseEnter = (event) => {
    this.props.onFocus(this.option, event);
  };

  handleMouseMove = (event) => {
    if (this.props.isFocused) return;
    this.props.onFocus(this.option, event);
  };

  get option() {
    return this.props.option;
  }

  render() {
    const flagClass = `flag flag-${this.option.value.toLowerCase()}`;
    return (
      <div
        className={this.props.className}
        onMouseDown={this.handleMouseDown}
        onMouseEnter={this.handleMouseEnter}
        onMouseMove={this.handleMouseMove}
        title={this.props.option.title}
      >
        <span className={flagClass} />
        &nbsp;&nbsp;
        {this.props.children}
      </div>
    );
  }
}

function CountryValue(props) {
  const flagClass = `flag flag-${props.value.value.toLowerCase()}`;

  return (
    <div className="Select-value" title={props.value.label}>
              <span className="Select-value-label">
        <span className={flagClass} />
        &nbsp;&nbsp;
        {props.children}
              </span>
    </div>
  );
}

CountryValue.propTypes = {
  children: PropTypes.node,
  placeholder: PropTypes.string,
  value: PropTypes.object
};

export default PhoneInput;
